import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getEditTabsAndNav as getEditTabsAndNavFromMonolith,
   TabType,
   EditTabsAndNav,
   GetEditTabsAndNavOptions,
} from '~/monolith-api';

const getEditTabsAndNavSchema = z.object({
   activeTab: z.enum(['intro', 'meta', 'steps', 'approval', 'quiz', 'periodic_review']),
   guideid: z.number(),
   stepid: z.number().optional(),
});

export async function getEditTabsAndNav(
   activeTab: TabType,
   guideid: number,
   options: GetEditTabsAndNavOptions
) {
   const response = await getEditTabsAndNavFromMonolith(activeTab, guideid, options);
   return response;
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { activeTab, guideid, stepid } = getEditTabsAndNavSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getEditTabsAndNav(activeTab, guideid, {
         apiClient: monolithClient,
         stepid,
      });
      res.status(200).json(result);
   },
});

export const getEditTabsAndNavFromClient = (
   activeTab: TabType,
   guideid: number,
   stepid?: number
): Promise<EditTabsAndNav> => {
   return bff()
      .post('/guides/getEditTabsAndNav', { activeTab, guideid, stepid })
      .then(response => response.data);
};

export type GetEditTabsAndNavErrorCode = 'guides.edit_tabs_and_nav_not_found';
